module.exports = __webpack_public_path__ + "img/service-2.79d5b28e.png";